import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { ExpertiseComponentContainer, FormContainer, FormItem } from '../../../../styles/styled';
import { PovsType } from '../../../PovsLkPage/types';

type PovsInfoPageProps = {
  povs: PovsType | null;
};

export const PovsInfoPage: FC<PovsInfoPageProps> = ({ povs }) => {
  return (
    <ExpertiseComponentContainer>
      <FormContainer padding="20px" background={'#fff'}>
        <Row gutter={[15, 15]}>
          <Col span={8}>
            <FormItem>
              <div className="text"> Email представителя</div>
              <div className="dark-text"> {povs?.email || '-'}</div>
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem>
              <div className="text"> Email органа власти</div>
              <div className="dark-text"> {povs?.povs?.email_gov}</div>
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem>
              <div className="text"> Регион</div>
              <div className="dark-text"> {povs?.region?.title}</div>
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem>
              <div className="text"> Адрес нахождения органа</div>
              <div className="dark-text"> {povs?.povs?.gov_loc || '-'}</div>
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem>
              <div className="text"> ФИО руководителя органа</div>
              <div className="dark-text"> {povs?.povs?.gov_fio}</div>
            </FormItem>
          </Col>
        </Row>
      </FormContainer>
    </ExpertiseComponentContainer>
  );
};
